import { https } from "../http";
import store from "../store";
import { setNoteSettings, setNoteSettingsLoading } from "../store/reducers/note";
import { showError } from "../utils/index";

// Org-level note settings (General, Notifications, Incident, AI & Voice,
// Reports). Kept intentionally separate from note-TYPE approval config.
// These helpers store the settings object in Redux (state.note.noteSettings)
// and also return it directly for callers that want it inline.

export const getNoteSettings = async () => {
  try {
    store.dispatch(setNoteSettingsLoading(true));
    const response = await https().get("/note-settings");
    if (response?.status === 200) {
      const settings = response?.data?.settings || null;
      store.dispatch(setNoteSettings(settings));
      return settings;
    }
    store.dispatch(setNoteSettingsLoading(false));
    return null;
  } catch (error) {
    store.dispatch(setNoteSettingsLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
    return null;
  }
};

// Read-only aggregation of every client's Care & Support "additional
// providers", used to populate the Other providers list in the incident tab.
export const getClientOtherProviders = async () => {
  try {
    const response = await https().get("/note-settings/client-providers");
    if (response?.status === 200) {
      return response?.data?.providers || [];
    }
    return [];
  } catch (error) {
    showError(error?.response?.data?.message, error?.response?.status);
    return [];
  }
};

// Sends a partial, whitelisted payload; the backend merges it without
// clobbering sibling groups and returns the full updated document.
export const updateNoteSettings = async (payload) => {
  try {
    const response = await https().put("/note-settings", payload);
    if (response?.status === 200) {
      const settings = response?.data?.settings || null;
      store.dispatch(setNoteSettings(settings));
      return settings;
    }
    return null;
  } catch (error) {
    showError(error?.response?.data?.message, error?.response?.status);
    return null;
  }
};
